export const foundInFilesLearnMoreUrl =
  'https://help.paperlessparts.com/s/article/Found-in-files-extractions';

export const partSetupToolLearnMoreUrl =
  'https://help.paperlessparts.com/s/article/Part-setup-tool';

export const foundInFilesLearnMoreClick = (
  event: React.MouseEvent<HTMLButtonElement>,
) => {
  //Prevent the accordianButton default behavior of expanding/collaposing accordian
  //And open the URL in new page
  //Still need `href, target and rel` attributes in case user right clicks on button
  window.open(foundInFilesLearnMoreUrl, '_blank', 'noopener,noreferrer');
  event.preventDefault();
};
